/* ============================================================
   gix.domains — INTERACTIVE DEMO CART  (prototype layer only)
   ------------------------------------------------------------
   Click a product card (.svc) → it's added to the slide-in drawer
   as a real line item with qty steppers, remove, and a live
   subtotal. In-memory only (resets on reload) — deliberately NOT a
   persistent/real cart, so porting to Shopify's own cart (AJAX
   Cart API / Liquid) stays clean and conflict-free. The markup &
   open/close live in gix-templates.js; this only drives contents.
   ============================================================ */
(function () {
  "use strict";

  var state = [];                       // { key, name, price|null, unit, from, qty }
  var fmt = function (n) { return "$" + n.toLocaleString("en-US"); };

  /* ---- read product info off a clicked card ---- */
  function parseCard(card) {
    var nameEl = card.querySelector(".svc__name");
    if (!nameEl) return null;
    // name = the card title without the decorative index span
    var name = "";
    nameEl.childNodes.forEach(function (n) { if (n.nodeType === 3) name += n.textContent; });
    name = name.trim() || nameEl.textContent.trim();

    var priceEl = card.querySelector(".svc__price");
    var price = null, unit = "", from = false, quote = false;
    if (priceEl) {
      if (priceEl.classList.contains("svc__price--quote")) { quote = true; }
      from = !!priceEl.querySelector(".svc__from");
      var unitEl = priceEl.querySelector(".svc__unit");
      unit = unitEl ? unitEl.textContent.trim() : "";
      var m = priceEl.textContent.replace(/,/g, "").match(/\$(\d+(?:\.\d+)?)/);
      if (m && !quote) price = parseFloat(m[1]);
    }
    var key = name.toLowerCase().replace(/[^a-z0-9]+/g, "-");
    return { key: key, name: name, price: price, unit: unit, from: from, quote: quote || price == null };
  }

  /* ---- mutations ---- */
  function add(card) {
    if (window.GIX_CART_SOURCE && window.GIX_CART_SOURCE.add) return window.GIX_CART_SOURCE.add(card);
    var p = parseCard(card); if (!p) return;
    var ex = state.filter(function (i) { return i.key === p.key; })[0];
    if (ex) { ex.qty++; } else { p.qty = 1; state.push(p); }
    render(); bump();
    if (window.GIX_CART && window.GIX_CART.open) window.GIX_CART.open();
  }
  function setQty(key, d) {
    if (window.GIX_CART_SOURCE && window.GIX_CART_SOURCE.setQty) return window.GIX_CART_SOURCE.setQty(key, d);
    var it = state.filter(function (i) { return i.key === key; })[0]; if (!it) return;
    it.qty += d;
    if (it.qty <= 0) { remove(key); return; }
    render();
  }
  function remove(key) {
    if (window.GIX_CART_SOURCE && window.GIX_CART_SOURCE.remove) {
      var dc = document.querySelector('.gcart__item[data-key="' + cssEsc(key) + '"]');
      if (dc) { dc.classList.add("is-leaving"); setTimeout(function () { window.GIX_CART_SOURCE.remove(key); }, 240); }
      else { window.GIX_CART_SOURCE.remove(key); }
      return;
    }
    var c = document.querySelector('.gcart__item[data-key="' + cssEsc(key) + '"]');
    if (c) {
      c.classList.add("is-leaving");
      setTimeout(function () { state = state.filter(function (i) { return i.key !== key; }); render(); }, 240);
    } else {
      state = state.filter(function (i) { return i.key !== key; }); render();
    }
  }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/"/g, '\\"'); }

  /* ---- render ---- */
  var XICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var EMPTY =
    '<div class="gcart__empty">' +
      '<span class="gcart__empty-node" aria-hidden="true"></span>' +
      '<p class="gcart__empty-t">Your cart is empty</p>' +
      '<span class="gcart__empty-s">Add a setup or service and it will appear here, ready to configure.</span>' +
    '</div>';

  function itemHTML(it) {
    var meta = (it.quote ? "Custom quote" : (it.from ? "From " : "") + fmt(it.price) + (it.unit ? " · " + it.unit : ""));
    var priceCell = it.quote
      ? '<span class="gcart__item-price is-quote">Quote</span>'
      : '<b class="gcart__item-price">' + fmt(it.price * it.qty) + '</b>';
    return '<div class="gcart__item" data-key="' + it.key + '">' +
        '<button class="gcart__rm" type="button" data-rm aria-label="Remove ' + it.name + '">' + XICON + '</button>' +
        '<p class="gcart__item-name">' + it.name + '</p>' +
        '<p class="gcart__item-meta">' + meta + '</p>' +
        '<div class="gcart__item-foot">' +
          '<div class="gcart__qty">' +
            '<button type="button" data-q="dec" aria-label="Decrease quantity">\u2212</button>' +
            '<span>' + it.qty + '</span>' +
            '<button type="button" data-q="inc" aria-label="Increase quantity">+</button>' +
          '</div>' + priceCell +
        '</div>' +
      '</div>';
  }

  function render() {
    /* ---- data source: real Shopify cart when wired (GIX_CART_SOURCE),
       else the in-memory demo `state`. itemHTML / DOM / CSS stay unchanged. ---- */
    var items = (window.GIX_CART_SOURCE && window.GIX_CART_SOURCE.items) ? window.GIX_CART_SOURCE.items() : state;
    /* ---- nav cart button (runs even if the drawer isn't present) ---- */
    var sum = 0, hasQuote = false, qty = 0;
    items.forEach(function (i) { qty += i.qty; if (i.quote) hasQuote = true; else sum += i.price * i.qty; });
    var priceText = !items.length ? "$0"
      : (sum === 0 && hasQuote) ? "By quote"
      : fmt(sum) + (hasQuote ? " +" : "");
    document.querySelectorAll(".cart").forEach(function (c) {
      c.classList.toggle("has-items", items.length > 0);
      var pr = c.querySelector(".cart__price"); if (pr) pr.textContent = priceText;
      var cn = c.querySelector(".cart__count"); if (cn) cn.textContent = qty;
      c.setAttribute("aria-label", items.length ? ("Cart, " + qty + " item" + (qty === 1 ? "" : "s") + ", " + priceText) : "Cart, empty");
    });

    var drawer = document.querySelector("[data-gix-cart]"); if (!drawer) return;
    var body = drawer.querySelector(".gcart__body");
    var totalEl = drawer.querySelector(".gcart__total");

    if (!items.length) {
      body.innerHTML = EMPTY;
    } else {
      body.innerHTML = '<div class="gcart__items">' + items.map(itemHTML).join("") + "</div>";
    }

    if (totalEl) {
      if (!items.length) totalEl.textContent = "$0.00";
      else if (sum === 0 && hasQuote) totalEl.textContent = "By quote";
      else totalEl.textContent = fmt(sum) + (hasQuote ? " +" : "");
    }
    var note = drawer.querySelector(".gcart__qnote");
    if (note) note.remove();
    if (hasQuote && sum > 0) {
      var row = drawer.querySelector(".gcart__foot .gcart__row");
      if (row) { var s = document.createElement("span"); s.className = "gcart__qnote"; s.textContent = "Quote items priced separately"; row.parentNode.insertBefore(s, row.nextSibling); }
    }
  }

  function bump() {
    var cart = document.querySelector(".cart"); if (!cart) return;
    cart.classList.remove("bump"); void cart.offsetWidth; cart.classList.add("bump");
  }

  /* ---- wire clicks (delegated, survives re-injected chrome) ---- */
  document.addEventListener("click", function (e) {
    // add: clicking a product card
    var card = e.target.closest && e.target.closest(".svc");
    if (card && !e.target.closest("[data-gix-cart]")) {
      // On the live store (real Shopify cart wired), service cards are LINKS to
      // their product page — every product needs configuration, so a card can't
      // add inline. Let the click follow the card's href (PDP). The in-memory
      // "click card → add to drawer" behavior is prototype-only (no GIX_CART_SOURCE).
      if (window.GIX_CART_SOURCE) return;
      e.preventDefault(); add(card); return;
    }

    // qty + remove inside the drawer
    var item = e.target.closest && e.target.closest(".gcart__item");
    if (item) {
      var key = item.getAttribute("data-key");
      if (e.target.closest("[data-rm]")) { e.preventDefault(); remove(key); return; }
      var q = e.target.closest("[data-q]");
      if (q) { e.preventDefault(); setQty(key, q.getAttribute("data-q") === "inc" ? 1 : -1); return; }
    }
  }, true);

  /* ---- (re)build the nav cart trigger into the icon-chip button ---- */
  function initCartButton() {
    document.querySelectorAll(".cart").forEach(function (c) {
      if (c.querySelector(".cart__chip")) return; // already upgraded
      c.innerHTML =
        '<span class="cart__chip" aria-hidden="true">' +
          '<span class="cart__count">0</span>' +
          '<svg class="cart__bag" viewBox="0 0 24 24">' +
            '<path d="M2.4 3.4h2.5l2.15 10.7a1.55 1.55 0 0 0 1.52 1.25h8a1.55 1.55 0 0 0 1.52-1.22l1.33-6.55H6.1"/>' +
            '<circle cx="9.4" cy="19.7" r="1.5"/>' +
            '<circle cx="17.4" cy="19.7" r="1.5"/>' +
          '</svg>' +
        '</span>' +
        '<span class="cart__slot">' +
          '<span class="cart__label">Cart</span>' +
          '<span class="cart__price">$0</span>' +
        '</span>';
    });
    render();
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartButton);
  } else { initCartButton(); }

  /* expose for the settings preview / programmatic use */
  window.GIX_CART = window.GIX_CART || {};
  window.GIX_CART.add = add;
  window.GIX_CART.refresh = render;   // Shopify source re-renders the drawer after async /cart.js
  window.GIX_CART.addByName = function (name) {
    var cards = [].slice.call(document.querySelectorAll(".svc"));
    var c = cards.filter(function (x) { var el = x.querySelector(".svc__name"); return el && el.textContent.indexOf(name) === 0; })[0];
    if (c) add(c);
  };
  window.GIX_CART.clear = function () { state = []; render(); };
  window.GIX_CART.state = function () { return state.slice(); };
})();
